Object.defineProperty(exports,"__esModule",{value:true});var _isFunction2=require("lodash/isFunction");var _isFunction3=_interopRequireDefault(_isFunction2);var _throttle2=require("lodash/throttle");var _throttle3=_interopRequireDefault(_throttle2);var _assign2=require("lodash/assign");var _assign3=_interopRequireDefault(_assign2);var _victoryCore=require("victory-core");

var _react=require("react");var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

var Helpers={
getDatasets:function getDatasets(props){
if(props.data){
return[{data:props.data}];
}
var getData=function getData(childProps){
var data=_victoryCore.Data.getData(childProps);
return Array.isArray(data)&&data.length>0?data:undefined;
};



var children=_react2.default.Children.toArray(props.children).reverse();
var childrenLength=children.length;
var dataArr=[];
var dataArrLength=0;
var childIndex=0;
while(childrenLength>0){
var child=children[--childrenLength];
var childName=child.props.name||childIndex;
childIndex++;
if(child.type&&child.type.role==="axis"){
childIndex++;
}else if(child.type&&(0,_isFunction3.default)(child.type.getData)){
dataArr[dataArrLength++]={childName:childName,data:child.type.getData(child.props)};
}else if(child.props&&child.props.children){
var newChildren=_react2.default.Children.toArray(child.props.children);
var newChildrenLength=newChildren.length;
for(var index=0;index<newChildrenLength;index++){
children[childrenLength++]=newChildren[index];
}
}else{
dataArr[dataArrLength++]={childName:childName,data:getData(child.props)};
}
}
return dataArr;
},

filterDatasets:function filterDatasets(datasets,bounds){var _this=this;
var filtered=datasets.reduce(function(memo,dataset){
var selectedData=_this.getSelectedData(dataset.data,bounds);
memo=selectedData?
memo.concat({
childName:dataset.childName,eventKey:selectedData.eventKey,data:selectedData.data}):

memo;
return memo;
},[]);
return filtered.length?filtered:null;
},

getSelectedData:function getSelectedData(dataset,bounds){var
x=bounds.x,y=bounds.y;
var withinBounds=function withinBounds(d){
return d._x>=x[0]&&d._x<=x[1]&&d._y>=y[0]&&d._y<=y[1];
};
var eventKey=[];
var data=[];
var count=0;
for(var index=0,len=dataset.length;index<len;index++){
var datum=dataset[index];
if(withinBounds(datum)){
data[count]=datum;
eventKey[count]=datum.eventKey===undefined?index:datum.eventKey;
count++;
}
}
return count>0?{eventKey:eventKey,data:data}:null;
},

onMouseDown:function onMouseDown(evt,targetProps){
evt.preventDefault();var
dimension=targetProps.dimension,scale=targetProps.scale;var _Selection$getSVGEven=
_victoryCore.Selection.getSVGEventCoordinates(evt),x=_Selection$getSVGEven.x,y=_Selection$getSVGEven.y;
var x1=dimension!=="y"?x:_victoryCore.Selection.getDomainCoordinates(scale).x[0];
var y1=dimension!=="x"?y:_victoryCore.Selection.getDomainCoordinates(scale).y[0];
var x2=dimension!=="y"?x:_victoryCore.Selection.getDomainCoordinates(scale).x[1];
var y2=dimension!=="x"?y:_victoryCore.Selection.getDomainCoordinates(scale).y[1];
if((0,_isFunction3.default)(targetProps.onSelectionCleared)){
targetProps.onSelectionCleared();
}
return[
{
target:"parent",
mutation:function mutation(){
return{x1:x1,y1:y1,select:true,x2:x2,y2:y2};
}},
{
target:"data",
childName:targetProps.children?"all":undefined,
eventKey:"all",
mutation:function mutation(){return null;}}];


},

onMouseMove:function onMouseMove(evt,targetProps){var
dimension=targetProps.dimension,scale=targetProps.scale,select=targetProps.select;
if(!select){
return{};
}else{var _ret=function(){var _Selection$getSVGEven2=
_victoryCore.Selection.getSVGEventCoordinates(evt),x=_Selection$getSVGEven2.x,y=_Selection$getSVGEven2.y;
var x2=dimension!=="y"?x:_victoryCore.Selection.getDomainCoordinates(scale).x[1];
var y2=dimension!=="x"?y:_victoryCore.Selection.getDomainCoordinates(scale).y[1];
return{v:{
target:"parent",
mutation:function mutation(){
return{x2:x2,y2:y2};
}}};}();if(typeof _ret==="object")return _ret.v;

}
},

onMouseUp:function onMouseUp(evt,targetProps){var
x2=targetProps.x2,y2=targetProps.y2;
var parentMutation=[{
target:"parent",
mutation:function mutation(){
return{select:false,x1:null,x2:null,y1:null,y2:null};
}}];

if(!x2||!y2){
return parentMutation;
}
var bounds=_victoryCore.Selection.getBounds(targetProps);
var datasets=this.getDatasets(targetProps);
var selectedData=this.filterDatasets(datasets,bounds);
var callbackMutation=selectedData&&(0,_isFunction3.default)(targetProps.onSelection)?
targetProps.onSelection(selectedData,bounds):{};
var dataMutation=selectedData?
selectedData.map(function(d){
return{
childName:d.childName,eventKey:d.eventKey,target:"data",
mutation:function mutation(){
return(0,_assign3.default)({active:true},callbackMutation);
}};

}):[];
return parentMutation.concat(dataMutation);
}};exports.default=


{
onMouseDown:Helpers.onMouseDown.bind(Helpers),
onMouseUp:Helpers.onMouseUp.bind(Helpers),
onMouseMove:(0,_throttle3.default)(Helpers.onMouseMove.bind(Helpers),16,{leading:true})};


//////////////////
// WEBPACK FOOTER
// ./~/victory-chart/lib/components/containers/selection-helpers.js
// module id = 521
// module chunks = 0